export enum WorkflowEventType {
  CAMPAIGN_SENT = 'campaign_sent',
  FEEDBACK_CREATED = 'feedback_created',
  STATUS_CHANGED = 'status_changed',
  TICKET_ASSIGNED = 'ticket_assigned',
  TICKET_CREATED = 'ticket_created',
  TICKET_REASSIGNED = 'ticket_reassigned',
  WORKFLOW_COMPLETED_EVENT = 'workflow_completed',
}
